import React from "react";
import { Layout } from "antd";

const Footer: React.FC = () => {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <div className="copyright">
        © 2025 Nebecom - Empowering eCommerce Brands
      </div>
    </AntFooter>
  );
};

export default Footer;
